import React, { Component } from "react";
import { connect } from "react-redux";
import ItemsContainer from "./ItemsContainer";
import { PageTitle } from "./PageTitle";
import { ContentContainer } from "./ContentContainer";

class Item extends Component {
    render() {
        const { filter, items, showDetails, getCrossSellProducts, accessorySubTitle, addToCartCb, showLoadingStatus } = this.props;

        return (
            <div>
                {accessorySubTitle ?
                    <div>
                        <ContentContainer>
                            <div className="row">
                                <div className="col-md-12">
                                    <h3 className="subCategoryTitle">{accessorySubTitle}</h3>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <ItemsContainer
                                                items={items}
                                                filter={filter}
                                                addToCart={true}
                                                showDetails={showDetails}
                                                getCrossSellProducts={getCrossSellProducts}
                                                addToCartCb={addToCartCb}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ContentContainer>
                    </div>
                    :
                    <div>
                        <PageTitle title={filter}/>
                        <ContentContainer>
                            <div className="row">
                                <div className="col-md-12">
                                    <ItemsContainer
                                        items={items}
                                        filter={filter}
                                        addToCart={true}
                                        showDetails={showDetails}
                                        getCrossSellProducts={getCrossSellProducts}
                                        addToCartCb={addToCartCb}
                                        showLoadingStatus={showLoadingStatus}
                                    />
                                </div>
                            </div>
                        </ContentContainer>
                    </div>
                }
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        Item: state.Item
    };
}

export default connect(mapStateToProps)(Item);
